<template>
  <div class="list-detail">
    <Alert v-if="+vacationData.status === 3" type="error" class="nopass">
      <span class="alert-title">
        <Icon type="android-alert" size="20"></Icon>
        审批不通过
      </span>
      <span class="alert-detail">
        <i-input type="textarea" autosize :value="vacationData.auditReason" disabled></i-input>

        <!--{{vacationData.auditReason}}-->
      </span>
    </Alert>
    <div>
      <vacation-form is-display :vaca-values="vacationData" v-if="!isLoading"></vacation-form>
      <div class="g-ta-r">
        <template v-if="vacationData.canReview">
          <Button type="primary" class="submit-btn form-default-btn hollow-default" size="large"
            @click.native="showModal(3)">审核不通过</Button>
          <Button type="primary" class="submit-btn form-default-btn" size="large" @click.native="audit(2)">审核通过</Button>
        </template>
        <template v-if="vacationData.canEdit">
          <Button type="primary" class="submit-btn form-default-btn" size="large" @click.native="toEdit">编辑申请</Button>
        </template>
        <template v-if="vacationData.canCancel">
          <Button type="primary" class="submit-btn form-default-btn" size="large"
            @click.native="cancelConfirm">撤销申请</Button>
        </template>
        <!-- 解除注释销假 -->
        <template v-if="
          vacationData.show_xiaojia_btn == 'true' &&
          vacationData.xiaojia_reason == ''
        ">
          <Button type="primary" class="submit-btn form-default-btn" size="large"
            @click.native="cancelVacaItem">销假</Button>
        </template>
      </div>

      <Modal v-model="isUndo" class-name="" ok-text="确定撤销" :closable="false" @on-ok="cancelVaca">
        <h2 slot="header">撤销请假</h2>
        <div>
          <p>确定撤销请假？</p>
        </div>
      </Modal>
      <Modal v-model="isModal" class-name="vertical-center-modal examine-modal" ok-text="提交" width="480px"
        :closable="false">
        <i-input type="textarea" v-model="modalValue" :autosize="{ minRows: 5 }" placeholder="填写不通过的理由"></i-input>
        <span class="words-count" :class="{ 'over-length': modalValue.length > 1000 }">{{ modalValue.length
        }}/1000</span>
        <div slot="footer" class="custom-footer">
          <Button type="primary" size="large" class="ok" @click.native="audit(nopassState, modalValue)"
            :disabled="modalValue.length > 1000">提交</Button>
        </div>
      </Modal>
    </div>

    <loading v-if="isLoading"></loading>
    <toast :is-toast="isToast" :msg="toastMsg" :status="toastState"></toast>

    <Modal v-model="cancelVacaDialog" class-name="vertical-center-modal  new-modal-vacation-detail" ok-text="提交"
      width="800px">
      <p slot="header" style="text-align: center; font-size: 16px">确认销假</p>
      <div class="cancel-message">
        <span style="margin-left: 46px">请假关联考勤，请谨慎操作，销假后请注意打卡，若无打卡及外出记录，人事将做缺勤处理。</span>
      </div>
      <div class="cancel-content" style="margin-top: 40px;">
        <Form ref="formInline" :model="formInline" :rules="ruleInline" label-position="top">
          <FormItem prop="xiaojia_time" label="销假时间">
            <p
              style="border:1px solid #4098f9;color:#4098f9;border-radius: 20px; width: 300px;text-align: center;height: 30px;">
              <!-- {{ vacationData.startTime }} —— {{ vacationData.endTime }} -->{{vacaDays[0]}}
            </p>
            <!-- <CheckboxGroup> -->
            <!-- <Checkbox label="全部"></Checkbox> -->
            <!-- <template v-for="(item, index) in vacationData.holiday_arr">
                <Checkbox :label="item"></Checkbox>
              </template> -->
            <!-- <Checkbox  v-model="check">{{vacationData.startTime}}  ——   {{vacationData.endTime}}</Checkbox> -->
            <!-- </CheckboxGroup> -->
          </FormItem>
          <FormItem prop="xiaojia_reason" label="销假原因">
            <Input type="textarea" v-model="formInline.xiaojia_reason" :maxlength="120" :rows="4"
              placeholder="请输入取消本次销假的原因" style="width: 752px">
            </Input>
          </FormItem>
        </Form>
      </div>
      <div slot="footer" class="custom-footer">
        <Button size="large" @click="cancelItem()">取消</Button>
        <Button type="primary" size="large" @click="handleSubmitCancelVaca('formInline')">提交</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import Loading from "./popup/Loading";
import Toast from "./popup/Toast";
import { Schedule } from "../API/api";
import VacationForm from "./VacationForm";
import { ajax } from "../util/util";
import debounce from "../util/debounce";
// 1待PAR审核，2PAR审核不通过 3 PAR审核通过 4待PIB审核，5PIB审核不通过 6审核通过执行中
export default {
  name: "vacation-detail",
  components: {
    VacationForm,
    Loading,
    Toast,
  },
  data() {
    return {
      modalValue: "",
      isModal: false,
      isLoading: false,
      isToast: false,
      toastMsg: null,
      toastState: null,
      vacationData: {},
      vacaDays:"",
      nopassState: null,
      isUndo: false,
      cancelVacaDialog: false,
      check: true,
      formInline: {
        xiaojia_time: [],
        xiaojia_reason: "",
      },
      ruleInline: {
        // xiaojia_time: [
        //   {
        //     required: true,
        //     type: "array",
        //     min: 1,
        //     message: "请选择销假时间",
        //     trigger: "change",
        //   },
        // ],
        xiaojia_reason: [
          {
            required: true,
            message: "请输入销假原因",
            trigger: "blur",
          },
          {
            type: "string",
            max: 120,
            message: "销假原因最多120个字",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    isDetail() {
      return this.$store.state.vacation.detail;
    },
    selectedProject() {
      return this.$store.state.vacation.detail;
    },
  },
  watch: {
    isDetail: {
      handler(val) {
        if (val) {
          this.getDetail();
        }
      },
      immediate: true,
    },
  },
  methods: {
    //取消销假
    cancelItem() {
      this.cancelVacaDialog = false;
      this.formInline = {
        xiaojia_time: [],
        xiaojia_reason: "",
      };
    },
    handleSubmitCancelVaca(name) {
      debounce(() => {
        this.$refs[name].validate((valid) => {
          this.formInline.id = this.vacationData.id;
          this.formInline.xiaojia_time = this.vacationData.holiday_arr;
          if (valid) {
            this.$http
              .post(Schedule.xiaojia, this.qs.stringify(this.formInline), {
                headers: {
                  Authorization: "Bearer " + this.$cookie.get("token"),
                },
              })
              .then((res) => {
                console.log(res, "res====");
                let _data = res.data;
                if (_data.retCode !== 0) {
                  this.isToast = true;
                  this.toastMsg = _data.retMsg;
                } else {
                  this.isToast = true;
                  this.toastMsg = "提交成功";
                  this.toastState = "success";
                }
                setTimeout(() => {
                  this.isToast = false;
                  this.toastState = null;
                  this.toastMsg = null;
                  this.modalValue = "";
                  this.$emit("on-cancel");
                  this.getDetail();
                }, 1500);
              });
            // this.$Message.success('Success!');
          } else {
            // this.$Message.error('Fail!');
          }
        });
      }, 500);
    },
    //销假
    cancelVacaItem() {
      this.cancelVacaDialog = true;
    },
    cancelConfirm() {
      this.isUndo = true;
    },
    cancelVaca() {
      ajax
        .post(Schedule.cancelVaca, {
          id: this.selectedProject.id,
        })
        .then(() => {
          this.isToast = true;
          this.toastMsg = "撤销请假成功";
          this.toastState = "success";
          setTimeout(() => {
            this.isToast = false;
            this.$emit("on-cancel");
          }, 1500);
        })
        .catch((err) => {
          this.isToast = true;
          this.toastState = null;
          this.toastMsg = err.toString();
          setTimeout(() => {
            this.isToast = false;
          }, 1500);
        })
        .finally();
    },
    audit(state, reason) {
      let data = {
        id: this.selectedProject.id,
        state: state,
        reason: reason,
      };
      this.isModal = false;
      this.$http
        .post(Schedule.vacaAudit, this.qs.stringify(data), {
          headers: {
            Authorization: "Bearer " + this.$cookie.get("token"),
          },
        })
        .then((res) => {
          let _data = res.data;
          this.isLoading = false;
          if (_data.retCode !== 0) {
            this.isToast = true;
            this.toastMsg = _data.retMsg;
          } else {
            this.isToast = true;
            this.toastMsg = "提交成功";
            this.toastState = "success";
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastState = null;
            this.toastMsg = null;
            this.modalValue = "";
            this.$emit("on-cancel");
            this.getDetail();
          }, 1500);
        });
    },
    showModal(state) {
      // 1 待审核 2 审核通过 3 审核不通过 4 删除
      this.isModal = true;
      this.nopassState = state;
    },
    toEdit() {
      this.$router.push(`/vacation/edit-apply/${this.selectedProject.id}`);
    },
    getDetail() {
      this.isLoading = true;

      this.$http
        .post(
          Schedule.vacaDetail,
          this.qs.stringify({
            id: this.selectedProject.id,
          }),
          {
            headers: {
              Authorization: "Bearer " + this.$cookie.get("token"),
            },
          }
        )
        .then((res) => {
          let _data = res.data;
          this.isLoading = false;
          if (_data.retCode === 0) {
            this.vacationData = _data.retData;
            this.vacaDays = [`${this.vacationData.startTime.split(' ')[0]} ${this.vacationData.startTime.split(' ')[1].split(':')[0] == "09" ? '上午' : (this.vacationData.startTime.split(' ')[1].split(':')[0] == "14" ? '下午' : (this.vacationData.startTime.split(' ')[1].split(':')[0] == "10" ? '上午' : '下午'))}  至   ${this.vacationData.endTime.split(' ')[0]} ${this.vacationData.endTime.split(' ')[1].split(':')[0] == "18" ? '下午' : (this.vacationData.endTime.split(' ')[1].split(':')[0] == "14" ? '上午' : (this.vacationData.endTime.split(' ')[1].split(':')[0] == "19" ? '下午' : '上午'))}`]

            // console.log(this.vacationData,'this.vacationData')
            console.log(this.vacaDays,'1231-----')
          } else if (_data.retCode === 100014) {
            this.$cookie.delete("token");

            this.isToast = true;
            this.toastMsg = _data.retMsg;
          }
          setTimeout(() => {
            this.isToast = false;
            this.toastMsg = null;
            if (_data.retCode === 100014) {
              this.$cookie.delete("token");

              this.$router.push("/");
            }
          }, 1500);
        });
    },
  },
};
</script>

<style scoped lang="less">
.list-detail {
  position: relative;
  padding: 16px;
  background-color: #ced4da;

  >div:not(.nopass) {
    padding: 32px 32px 32px 64px;
    background-color: #fff;
    margin-bottom: 16px;
  }
}

.cancel-message {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 88px;
  width: 800px;
  height: 48px;
  background: rgba(249,226,228);
  span {
    width: 574px;
    height: 20px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #E02020;
    line-height: 48px;
    opacity: 1;
  }
}

.task-belong {
  a {
    text-decoration: underline;
  }
}
</style>
